export default {"src":"/_next/static/media/phone_40.7bd06e66.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};